import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space, Tooltip } from 'antd';
import { useContext, useEffect, useState } from 'react';

import {
  RIGHTS_SALES_REGISTER,
  RIGHTS_IS_CREATE_COLLECTION,
  RIGHTS_IS_CREATE_EXPENSE,
  RIGHTS_IS_ON,
  RIGHTS_IS_TOPPING_UP_CASH,
  TABLET,
  RIGHTS_IS_EXPORT,
} from '@app/constants';
import { useAccessRights, useExportToExcel, useWindowSize } from '@app/hooks';
import { ClientPaymentsContext } from '@app/providers';

import { useDropdownItems } from '@pages/Clients/ClientPayments/ClientPaymentsList/hooks';

import type { MenuProps } from 'antd';

export const ClientPaymentsHeader = () => {
  const [label, setLabel] = useState('Добавить');
  const [loader, setLoader] = useState(false);

  const { exportClientPaymentsToExcel } = useExportToExcel({ setLoader });

  const { innerWidth } = useWindowSize();
  const { hasUserRight: hasUserRightForModuleView } = useAccessRights(
    RIGHTS_SALES_REGISTER,
    RIGHTS_IS_ON
  );
  const { hasUserRight: hasUserRightToCreateExpense } = useAccessRights(
    RIGHTS_SALES_REGISTER,
    RIGHTS_IS_CREATE_EXPENSE
  );
  const { hasUserRight: hasUserRightToCreateCollection } = useAccessRights(
    RIGHTS_SALES_REGISTER,
    RIGHTS_IS_CREATE_COLLECTION
  );
  const { hasUserRight: hasUserRightToToppingUpRegister } = useAccessRights(
    RIGHTS_SALES_REGISTER,
    RIGHTS_IS_TOPPING_UP_CASH
  );
  const { hasUserRight: hasUserRightToExportInExcel } = useAccessRights(
    RIGHTS_SALES_REGISTER,
    RIGHTS_IS_EXPORT
  );

  const {
    setIsPaymentsModalOpen,
    setIsCollectionsModalOpen,
    setIsExpensesModalOpen,
    searchId,
  } = useContext(ClientPaymentsContext);

  const { items } = useDropdownItems({
    openPaymentsModal: () => setIsPaymentsModalOpen(true),
    openCollectionsModal: () => setIsCollectionsModalOpen(true),
    openExpensesModal: () => setIsExpensesModalOpen(true),
  });

  const excelItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div
          onClick={() => exportClientPaymentsToExcel(searchId)}
          data-testid="export-to-file"
        >
          Выгрузить в файл
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (innerWidth <= TABLET) {
      setLabel('');
    } else {
      setLabel('Добавить');
    }
  }, [innerWidth]);

  if (
    !hasUserRightForModuleView &&
    (!hasUserRightToCreateExpense ||
      !hasUserRightToCreateCollection ||
      !hasUserRightToToppingUpRegister)
  ) {
    return <></>;
  }

  return (
    <Space>
      {hasUserRightToExportInExcel && (
        <Dropdown menu={{ items: excelItems }} placement="bottomRight">
          <Tooltip title={loader ? 'Выгрузка в процессе...' : ''}>
            <Button
              loading={loader}
              disabled={loader}
              data-testid="excel-operations"
            >
              <Space>
                <span>Операции с Excel</span>
                <DownOutlined />
              </Space>
            </Button>
          </Tooltip>
        </Dropdown>
      )}
      {(hasUserRightToCreateExpense ||
        hasUserRightToCreateCollection ||
        hasUserRightToToppingUpRegister) && (
        <Dropdown menu={{ items }} placement="bottomLeft">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            data-testid="add-operation"
          >
            {label}
          </Button>
        </Dropdown>
      )}
    </Space>
  );
};
